export var max = Math.max;
export var min = Math.min;
export var round = Math.round;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@popperjs/core/lib/utils/math.js
// module id = 168
// module chunks = 3